import React from 'react';
import { ENGINE_ICON_MAP } from '@laigu/constants';

import MyIcon from '../my-icon';

interface PropsTypes {
  system?: string;
  className?: string;
}

const replaceSystem = (browser_family: string) => {
  if (browser_family) {
    // 将空格和「.」替换为「-」
    return browser_family.toLowerCase().replace(/(\s|\.)+/g, '-');
  }
  return '';
};

const SystemIcon = ({ system, className }: PropsTypes): JSX.Element => {
  if (!system) {
    return <></>;
  }
  const systemLowerCase = replaceSystem(system);
  const iconClassName = ENGINE_ICON_MAP[systemLowerCase];
  return (
    <MyIcon
      type={`ecoboost-iconfont${iconClassName || 'unknown'}`}
      className={`${className}`}
      title={systemLowerCase || ''}
    />
  );
};

SystemIcon.defaultTypes = {
  system: '',
  className: ''
};

export default SystemIcon;
